import script from "./ResponseModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ResponseModal.vue?vue&type=script&setup=true&lang=js"

import "./ResponseModal.vue?vue&type=style&index=0&id=d4fc03b6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d4fc03b6"]])

export default __exports__